import { RANK_VALUES, SUITS } from "./constants.js";

let cardIdCounter = 0;

export function createCard(suit, rank, id) {
  if (!RANK_VALUES[rank]) {
    throw new Error(`Invalid card rank: ${rank}`);
  }

  return {
    id: id ?? `${suit}-${rank}-${cardIdCounter++}`,
    suit,
    rank
  };
}

export function getRankValue(card) {
  return RANK_VALUES[card.rank];
}

export function compareCardsForHandSort(a, b) {
  const rankDelta = getHandSortRankValue(a) - getHandSortRankValue(b);
  if (rankDelta !== 0) {
    return rankDelta;
  }

  const suitDelta = SUITS.indexOf(a.suit) - SUITS.indexOf(b.suit);
  if (suitDelta !== 0) {
    return suitDelta;
  }

  return String(a.id).localeCompare(String(b.id));
}

export function isHandSorted(cards) {
  for (let index = 1; index < cards.length; index += 1) {
    if (compareCardsForHandSort(cards[index - 1], cards[index]) > 0) {
      return false;
    }
  }

  return true;
}

export function isSameCard(a, b) {
  return Boolean(a && b && a.id === b.id);
}

export function resetCardIdCounterForTests() {
  cardIdCounter = 0;
}

function getHandSortRankValue(card) {
  if (card.rank === "2") {
    return 15;
  }

  if (card.rank === "10") {
    return 16;
  }

  return RANK_VALUES[card.rank] ?? 0;
}
